import axios from 'axios';
import ypStore from 'js-cookie';
import Bowser from 'bowser';
import moment from 'moment';
import ypRequest from '@utils/ypRequest/';
const browser = Bowser.getParser(window.navigator.userAgent);
// console.log(`------`, browser.getOSName());
// console.log(`------2`, browser.getOSVersion());
// console.log(`------3`, browser.getOS());
// console.log(`------4`, browser.getPlatform());

// console.log(`The current browser name is "${browser.getBrowserName()}"`);
// console.log(browser.getBrowser());
// console.log(moment().format('YYYY-MM-DD HH:mm:ss'));
function S4() {
  // tslint:disable-next-line:no-bitwise
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
// Generate a pseudo-GUID by concatenating random hexadecimal.
export function guid() {
  return (
    S4() +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    '-' +
    S4() +
    S4() +
    S4()
  );
}
async function trackEvent(
  token: string,
  mobile: number,
  tenantId: number,
  env: string
) {
  try {
    const dataVal = { tenantId, phone: mobile };
    const res: any = await ypRequest('auth.subject.getSubjectByPhone', dataVal);
    if (res.success) {
      if (res.result.success) {
        const item = res.result.data;
        const user = `${item.relName}${item.phone} ${moment().format(
          'YYYY-MM-DD HH:mm:ss'
        )}`;
        const OSVAL = `${browser.getOS().name}-${browser.getOS().versionName}-${
          browser.getOS().version
        }`;
        const desc = `在${OSVAL},用 ${browser.getBrowser().name}${
          browser.getBrowser().version
        } 登录`;
        const msg = user + desc;
        (window as any)._czc.push(['_trackEvent', '中台访问', '点击登录', msg]);
        const clientWidth = document.body.clientWidth;
        const clientHeight = document.body.clientHeight;
        const screenHeight = window.screen.height;
        const screenWidth = window.screen.width;
        const msg2 = `${item.relName}${item.phone}的游览器,网页可见区域${clientWidth}*${clientHeight},屏幕分辨率${screenWidth}*${screenHeight}`;
        (window as any)._czc.push(['_trackEvent', '屏幕分辨率', '信息', msg2]);
      }
    }
  } catch (error) {}
}
export default trackEvent;
